import { render, staticRenderFns } from "./UpdatePurchaseCodeDialog.vue?vue&type=template&id=64bc4016&"
import script from "./UpdatePurchaseCodeDialog.vue?vue&type=script&lang=js&"
export * from "./UpdatePurchaseCodeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports